export const Props = () => ({
  //Тип кнопки
  type: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'secondary', 'alert', 'secondaryReverse', 'gray', 'blue-border', 'blue-gradient'].includes(value)
  },

  //Ширина кнопки
  width: {
    type: String,
    default: 'fit-content',
  },

  //Высота кнопки
  height: {
    type: String,
    default: '40px',
  },

  //Активна кнопка или нет
  disabled: {
    type: Boolean,
    default: false,
  },

  //Адрес перехода по клику, если необходимо
  link:{
    type: String,
  },

  //Отобразить процесс загрузки или нет
  loading: {
    type: Boolean,
    default: false,
  },

  //Закругление краев кнопки
  radius: {
    type: String,
  },

  //Открытие в этой вкладке или в другой
  target: {
    type: String,
    validator: (value) => !value || ['_blank', '_self', '_parent', '_top'].includes(value)
  },

  // Внутренние отступы кнопки
  padding: {
    type: String,
    default: '0 16px',
  },

  //Размер текста
  fontSize: {
    type: String,
    default: '16px',
  }
});
